import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=6f6d2adf&"
import script from "./Price.vue?vue&type=script&lang=ts&"
export * from "./Price.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports